<template>
  <div
    v-if="stockStatus && stockStatus.deliveryDateDescription"
    class="delivery-promise message message--success"
  >
    <IconCheckCircle class="message__icon icon icon--info" />
    <span>
      <span
        v-if="stockStatus?.status === 1"
        class="delivery-promise__stock-info"
        v-text="`${$t('1 left in stock')} - `"
      />
      {{ stockStatus.deliveryDateDescription }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type {
  AvelonStockStatus,
} from '~layers/app/types/avelon'

const props = defineProps<{
  selectedSku?: string[] | string | null
}>()

const meta = inject('meta', ref())
const { loadAvelonStockData, AvelonStockData, pendingAvelonStock } = usePDP(meta)

const currentSku = computed(() => {
  if (!props.selectedSku) return null

  if (Array.isArray(props.selectedSku) && props.selectedSku.length > 0) {
    return props.selectedSku[0].toLowerCase()
  }
  else if (typeof props.selectedSku === 'string') {
    return props.selectedSku.toLowerCase()
  }

  return null
})

const stockStatus = computed<AvelonStockStatus | null>(() => {
  if (pendingAvelonStock.value || !AvelonStockData.value?.getStock?.stockStatus || !currentSku.value) {
    return null
  }

  const stockStatusArray = AvelonStockData.value.getStock.stockStatus

  if (!Array.isArray(stockStatusArray)) {
    return null
  }
  return stockStatusArray.find(
    status => status?.sku?.toLowerCase?.() === currentSku.value,
  ) || null
})

onMounted(() => {
  if (pendingAvelonStock) {
    loadAvelonStockData()
  }
})
</script>

<style src="~layers/app/components/Product/Availability/DeliveryPromise.css" />
